var _g, _path, _path2, _g2, _g3, _path3, _g4, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgForBusiness = function SvgForBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 236,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#for_business_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123.481,
    height: 123.481,
    fill: "#3B7CC9",
    rx: 32.495,
    transform: "matrix(-1 0 0 1 219.455 48.03)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M179.451 77.079h-26.864v18.226a2.184 2.184 0 0 1-2.184 2.184h-18.226v41.214a3.12 3.12 0 0 0 3.12 3.121h44.154a3.12 3.12 0 0 0 3.121-3.121V80.199a3.12 3.12 0 0 0-3.121-3.12m-12.299 51.816h-17.786a2.184 2.184 0 0 1 0-4.368h17.786a2.184 2.184 0 0 1 0 4.368m0-10.275h-17.786a2.184 2.184 0 0 1 0-4.369h17.786a2.184 2.184 0 0 1 0 4.369m0-10.276h-17.786a2.184 2.184 0 0 1 0-4.369h17.786a2.184 2.184 0 0 1 0 4.369"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M148.192 77.079c-.827 0-1.621.329-2.206.914l-12.895 12.895a3.12 3.12 0 0 0-.914 2.206v.027h16.042V77.079z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#for_business_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.493,
    height: 45.493,
    fill: "#FCB701",
    rx: 11.698,
    transform: "matrix(-1 0 0 1 249.508 35.275)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#for_business_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.493,
    height: 45.493,
    fill: "#51C394",
    rx: 11.698,
    transform: "matrix(-1 0 0 1 113.706 134.314)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3F3FF",
    d: "M89.551 52.827c-.96 3.624-4.665 5.78-8.278 4.817s-5.764-4.68-4.804-8.304 4.667-5.781 8.28-4.818c3.613.962 5.762 4.68 4.802 8.305M250.287 158.476c-.96 3.624-4.666 5.78-8.278 4.817s-5.764-4.68-4.804-8.304 4.667-5.782 8.279-4.819 5.762 4.682 4.803 8.306"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.042,
    clipPath: "url(#for_business_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M102.555 158.742c0 2.424-.719 4.793-2.065 6.809a12.26 12.26 0 0 1-12.58 5.21 12.256 12.256 0 0 1 2.39-24.273m-12.254 12.254h14.14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M90.302 146.488a21.15 21.15 0 0 0-4.714 12.254 21.15 21.15 0 0 0 4.714 12.255 21.15 21.15 0 0 0 4.375-9.426"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A9FFDC",
    d: "M92.122 151.608c-.715-.123-.715-1.152 0-1.277a6.48 6.48 0 0 0 5.227-5.004l.04-.198c.158-.708 1.165-.714 1.328-.006l.051.231a6.52 6.52 0 0 0 5.241 4.973c.719.125.719 1.16 0 1.287-1.267.22-2.44.81-3.372 1.695a6.5 6.5 0 0 0-1.869 3.278l-.051.229c-.163.707-1.17.703-1.328-.006l-.04-.196a6.49 6.49 0 0 0-5.227-5.006"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M218.5 48c-.621 0-1.125.504-1.125 1.125v13.5a4.5 4.5 0 0 0 4.5 4.5h11.25c1.717 0 2.898-.74 3.613-1.733.673-.936.887-2.024.887-2.767 0-.621-.504-1.125-1.125-1.125h-3.375V49.125c0-.621-.504-1.125-1.125-1.125zm6.75 13.5h5.625V50.25h-11.25v12.375a2.25 2.25 0 0 0 2.25 2.25 2.65 2.65 0 0 0 1.452-.463c.413-.298.798-.804.798-1.787 0-.621.504-1.125 1.125-1.125m.595 3.375h7.28c.983 0 1.489-.385 1.787-.798q.112-.157.194-.327h-8.848a4.3 4.3 0 0 1-.413 1.125m-3.97-11.25c0-.621.504-1.125 1.125-1.125h4.5a1.125 1.125 0 0 1 0 2.25H223a1.125 1.125 0 0 1-1.125-1.125m1.125 2.25a1.125 1.125 0 0 0 0 2.25h4.5a1.125 1.125 0 0 0 0-2.25z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "for_business_svg__a",
    width: 214.468,
    height: 214.467,
    x: 53.08,
    y: 12.935,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.6,
    dy: 10.398
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.747
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.351917 0 0 0 0 0.429167 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9013_146819"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9013_146819",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "for_business_svg__b",
    width: 136.479,
    height: 136.479,
    x: 161.121,
    y: 0.18,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.6,
    dy: 10.398
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.747
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.351917 0 0 0 0 0.429167 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9013_146819"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9013_146819",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "for_business_svg__c",
    width: 136.479,
    height: 136.479,
    x: 25.319,
    y: 99.219,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.6,
    dy: 10.398
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.747
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.351917 0 0 0 0 0.429167 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9013_146819"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9013_146819",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "for_business_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77 143.5h28.594v28.594H77z"
  })))));
};
export default SvgForBusiness;